import { GridCellProps } from '@progress/kendo-react-grid';
import React from 'react';
import { EXTENSION_FIELD } from '../../../config/consts';
import { GearGridCell } from './GearGridCell';
import { filePdfIcon, fileExcelIcon, fileWordIcon, fileImageIcon, fileIcon } from '@progress/kendo-svg-icons';
import { SvgIcon } from '@progress/kendo-react-common';

const getFileIcon = (extension: string) => {
  const ext = extension?.toLowerCase().replace('.', '');
  const iconProps = {
    size: 'medium' as const,
    style: { verticalAlign: 'middle' }
  };

  switch (ext) {
    case 'pdf':
      return <SvgIcon {...iconProps} icon={filePdfIcon} />;
    case 'xlsx':
    case 'xls':
    case 'csv':
      return <SvgIcon {...iconProps} icon={fileExcelIcon} />;
    case 'doc':
    case 'docx':
      return <SvgIcon {...iconProps} icon={fileWordIcon} />;
    case 'jpg':
    case 'jpeg':
    case 'png':
      return <SvgIcon {...iconProps} icon={fileImageIcon} />;
    default:
      return <SvgIcon {...iconProps} icon={fileIcon} />;
  }
};

export const ExtensionCell: React.FC<GridCellProps> = props => {
  const extension = props.dataItem[EXTENSION_FIELD];

  return (
    <GearGridCell {...props} title={extension || ''}>
      {getFileIcon(extension)}
    </GearGridCell>
  );
};
